// scroll bar on mobile
jQuery(document).ready(function () {
  jQuery(".tbl").scrollbar();
});
// function click open popup & accordion
$(function () {
  if ($(".box-product__favorite").length > 0) {
    $(".box-product__favorite").on("click", function () {
      $(this).toggleClass("active");
    });
  }
  if ($(".js-cart-add").length > 0) {
    $(".js-cart-add").on("click", function () {
      $("body").toggleClass("js-box-cart");
      $(".box-cart").toggleClass("js-box-cart");
      var __cur_p = $(window).scrollTop();
      var __cur_h = $("body").outerHeight();
      $("body").attr("data-position", __cur_p);
      $("body").css({
        top: "-" + __cur_p + "px",
        left: 0,
        width: "100%",
        height: __cur_h + "px",
        position: "fixed",
        "z-index": "-1",
        "touch-action": "none",
        "overflow-y": "auto",
      });
    });
    $(".close").click(function () {
      $("body").removeClass("js-box-cart");
      $(".box-cart").removeClass("js-box-cart");
      var $pos_position = $("body").attr("data-position");
      $("body").css({
        "touch-action": "auto",
        "overflow-x": "hidden",
        "overflow-y": "auto",
        position: "static",
        top: "auto",
        height: "auto",
      });
      $("html,body").scrollTop(Math.abs(Number($pos_position)));
      $("body").removeClass("layerOn");
    });
    $(document).on("click", function (event) {
      if (!$(event.target).closest(".box-cart,.hamberger,.header-nav__inner,.product-cont__inner,#wrap").length && !$(event.target).hasClass("js-cart-add")) {
        $(".box-cart").addClass("active");
        $("body").removeClass("js-box-cart");
        $(".box-cart").removeClass("js-box-cart");
        var $pos_position = $("body").attr("data-position");
        $("body").css({
          "touch-action": "auto",
          "overflow-x": "hidden",
          "overflow-y": "auto",
          position: "static",
          top: "auto",
          height: "auto",
        });
        $("html,body").scrollTop(Math.abs(Number($pos_position)));
        $("body").removeClass("layerOn");
      } else {
        $(".box-cart").removeClass("active");
      }
    });
  } else {
    resetBodyStyles();
  }
});
// Product gallery initialization is managed by product-color-gallery.js.

// anchor size chart
$(window).on("scroll load resize", function () {
  $(".slider1").each(function () {
    var items = $(this).find(".slick-slide");
    var hIndex = $(".box-acc .item:first").outerHeight();
    // console.log(hIndex);

    if (items.length <= 2) {
      $(".box-product").addClass("none");
      if ($(".box-product__guide").length > 0) {
        $(".box-product__guide").click(function () {
          $("#size-anchor").addClass("active");
          $("#size-anchor .ques").addClass("active");
          $("#size-anchor .ans").addClass("active").slideDown();
          if ($(window).width() > 767) {
            var xIndex = $(".box-acc .item.active");
            var yIndex = $(".box-acc .item:first-child").hasClass("active");
            if (xIndex.length > 1 && yIndex) {
              if (hIndex < 286) {
                var anchorTop = $(".box-acc").offset().top + 180 - hIndex * 2.6;
              } else {
                var anchorTop = $(".box-acc").offset().top + 180;
              }
              $("html, body").stop().animate(
                {
                  scrollTop: anchorTop,
                },
                600
              );
            } else {
              var anchorTop = $(".box-acc").offset().top - 50;
              $("html, body").stop().animate(
                {
                  scrollTop: anchorTop,
                },
                600
              );
            }
          } else {
            var anchorTop = $(".box-acc").offset().top;
            $("html, body").stop().animate(
              {
                scrollTop: anchorTop,
              },
              600
            );
          }
          // console.log(anchorTop);
        });
      }
    } else {
      $(".box-product").removeClass("none");
      if ($(window).width() > 767) {
        if ($(".box-product__guide").length > 0) {
          $(".box-product__guide").click(function () {
            setTimeout(() => {
              var anchorTop = $("#size-anchor").offset().top;
              $("html, body").stop().animate({
                scrollTop: anchorTop,
              });
            }, 1);
            setTimeout(() => {
              $("#size-anchor").toggleClass("active");
              $("#size-anchor .ques").addClass("active");
              $("#size-anchor .ans").addClass("active").slideDown();
            }, 500);
          });
        }

        function adjustSidebar() {
          var topPosition = $(window).scrollTop();
          var offsetTop = $(".js-sidebar-wrap").offset().top;
          var headerHeight = $(".header").outerHeight();
          var sidebarHeight = $(".js-sidebar-wrap").outerHeight();
          var fixedSidebarHeight = $(".js-sidebar-fixed").outerHeight();
          // if (topPosition > offsetTop - headerHeight && topPosition < offsetTop + sidebarHeight - fixedSidebarHeight - headerHeight) {
          //   $(".js-sidebar-fixed").removeClass("abs");
          // } else if (topPosition >= offsetTop + sidebarHeight - fixedSidebarHeight - headerHeight) {
          //   $(".js-sidebar-fixed").addClass("abs");
          // } else {
          //   $(".js-sidebar-fixed").removeClass("abs");
          // }
        }
        $(window).scroll(adjustSidebar);
      } else {
        $(document).ready(function () {
          if ($(".box-product__guide").length > 0) {
            $(".box-product__guide").click(function () {
              $("#size-anchor").toggleClass("active");
              $("#size-anchor .ques").addClass("active");
              $("#size-anchor .ans").addClass("active").slideDown();
              var anchorTop = $(".box-acc").offset().top;
              $("html, body").stop().animate(
                {
                  scrollTop: anchorTop,
                },
                600
              );
            });
          }
        });
      }
    }
  });
});

//
// ドロワーカートカスタマイズの別scriptはcart-drawer.liquidに書いている
//
$(".product-form__submit").on("click", function () {
  $("body").addClass("js-filter-cart");
  $("body").removeClass("fixHeader");
  $(".header").addClass("bg-white");
  var __cur_p = $(window).scrollTop();
  var __cur_h = $("body").outerHeight();
  $("body").attr("data-position", __cur_p);
  $("body").css({
    top: "-" + __cur_p + "px",
    left: 0,
    width: "100%",
    height: __cur_h + "px",
    position: "fixed",
    "z-index": "-1",
    "touch-action": "none",
    "overflow-y": "auto",
  });
});
// 監視ターゲットの取得
const targetProduct = document.querySelector(".product-form__error-message-wrapper");
const mObserver = new MutationObserver((records) => {
  resetBodyStyles();
  console.log("test");
});

mObserver.observe(targetProduct, {
  attributes: true,
});